export default "__VITE_ASSET__d7c81afb__"